import React,{useState, useEffect} from "react";
import { Link,useParams } from "react-router-dom";
import { var_api } from "../../constant";
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
// import '../Banner/Banner.css';
import './categories.css';
import axios from "axios";
import 'bootstrap-icons/font/bootstrap-icons.css';
import Swal from "sweetalert2";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip } from "reactstrap";
import all from '../../../images/sb-images/detoxi.webp';
import hairtre from '../../../images/sb-images/sage sig.webp';
import other from '../../../images/sb-images/scla.webp';
import facial from '../../../images/sb-images/fruit.webp';
import hydra from '../../../images/sb-images/hydrascalp.webp';
import clari from '../../../images/sb-images/clari.webp';
import puri from '../../../images/sb-images/puri.webp';
import { Button,Form} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useHistory } from "react-router-dom";
import Loader from "../Loader";


toast.configure()


function ServiceSubCategory(){
    const [cart, setCart] = useState([]);
    const [images, setImages] = useState([]);
    const [search, setSearch] = useState('');
    const shopName= localStorage.getItem('shopName');
    const [ loading, setLoading ] = useState(false);
    const [ activeCounts, setActiveCounts ] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    // const getQuery = event => setSearchQuery(event.target.value);
    const [users, setUsers] = useState([]); 
    const [puttooltipOpen, setPutToolTipOpen] = useState([]);
    const [categories, setCategories] = useState([]);
    const history = useHistory();
    const [isLogin, setIsLogin] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [show, setShow] = useState(false);
    const [categoryToDelete, setCategoryToDelete] = useState(null);
    const itemsPerPage = 10;
    const categoryName = localStorage.getItem('selectedCategoryName');
    console.log(shopName);

   
    // Function to convert string to camelCase
  const capitalizeEachWord = (str) => {
    return str.toLowerCase().replace(/(^|\s)\S/g, function (match) {
      return match.toUpperCase();
    });
  };
  const handleAdd = async () => {
    const { value: formValues } = await Swal.fire({
        title: 'Create Service',
        html: `
        <style>
          .swalLa {
            text-align: left; 
            display: block; 
            margin-bottom: 5px; 
            margin-left: 90px; 
            font-weight: bold; 
          }

          .swal2-input {
            margin-bottom: 10px; 
            padding: 10px; 
            border: 1px solid #ccc; 
            border-radius: 4px; 
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); 
          }

          .duration-display {
            font-weight: bold; 
            margin-bottom: 10px; 
          }
        </style>
        <label class="swalLa">Service Name</label>
        <input id="swal-input1" class="swal2-input fin" placeholder="Enter service name">
        <br/>
        <label class="swalLa">Description</label>
        <input id="swal-input2" class="swal2-input fin" placeholder="Enter description">
        <br/>
        <label class="swalLa">Service Duration (in minutes)</label>
        <input id="swal-input3" class="swal2-input fin" placeholder="Enter duration" type="number" min="0">
        <br/>
        <label id="durationDisplay" class="duration-display">Duration: 0 hours 0 minutes</label>
        <br/>
        <label class="swalLa">Service Price</label>
        <input id="swal-input4" class="swal2-input fin" placeholder="Enter price" type="number" min="0">
        <br/>
        <label class="swalLa">Membership Discount</label>
        <input id="swal-input6" class="swal2-input fin" placeholder="Enter membership discount" type="number" min="0">
        <br/>
        <label class="swalLa">Service Image</label>
        <input id="swal-input5" class="swal2-input fin" placeholder="Select File" type="file">
        <br/>
        <label class="swalLa">Select Gender</label>
        <select id="swal-input7" class="swal2-input fin">
            <option value="Male" selected>Male</option>
            <option value="Female">Female</option>
            <option value="Others">Others</option>
        </select>
        <br/>
        <label class="swalLa">Select Service Type</label>
        <select id="swal-input8" class="swal2-input fin">
            <option value="Room" selected>Room</option>
            <option value="Seat">Seat</option>
            <option value="Others">Others</option>
        </select>
      `,
        focusConfirm: false,
        confirmButtonColor: '#007500',
        confirmButtonText: 'Submit',
        showCancelButton: true,
        cancelButtonColor: '#ff0000',
        didOpen: () => {
            const durationInput = document.getElementById('swal-input3');
            const durationDisplay = document.getElementById('durationDisplay');

            // Update duration display dynamically as the input changes
            durationInput.addEventListener('input', () => {
                const durationInMinutes = parseInt(durationInput.value, 10) || 0; // Default to 0 if NaN
                const { hours, minutes } = convertToHoursMinutess(durationInMinutes);
                durationDisplay.textContent = `Duration: ${hours} hour${hours !== 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
            });
        },
        preConfirm: () => {
            const serviceName = document.getElementById('swal-input1').value;
            const description = document.getElementById('swal-input2').value;
            const serviceDuration = document.getElementById('swal-input3').value;
            const servicePrice = document.getElementById('swal-input4').value;
            const membershipDiscount = document.getElementById('swal-input6').value;
            const selectedFile = document.getElementById('swal-input5').files[0];
            const gender = document.getElementById('swal-input7').value;
            const serviceType = document.getElementById('swal-input8').value;

            if (!serviceName || !description || !serviceDuration || !servicePrice || !membershipDiscount || !gender || !serviceType) {
                Swal.showValidationMessage('Please fill in all the required fields');
                return;
            }

            return { serviceName, description, serviceDuration, servicePrice, selectedFile, membershipDiscount, gender, serviceType };
        }
    });

    if (formValues) {
        const { serviceName, description, serviceDuration, servicePrice, selectedFile, membershipDiscount, gender, serviceType } = formValues;
        const categoryId = localStorage.getItem('selectedCategoryId');
        const token = localStorage.getItem('token');
        const camelCaseServiceName = serviceName.replace(/\b\w/g, char => char.toUpperCase());

        const formData = new FormData();
        formData.append('service_name', camelCaseServiceName);
        formData.append('description', description);
        formData.append('service_duration', serviceDuration);
        formData.append('service_price', servicePrice);
        formData.append('membership_discount', membershipDiscount);
        formData.append('service_image', selectedFile);
        formData.append('category_id', categoryId);
        formData.append('gender', gender);  // Add gender to form data
        formData.append('service_type', serviceType);  // Add service type to form data

        try {
            setIsLogin(true);
            const response = await fetch(`${var_api}/api/sub-category-master/post`, {
                method: 'POST',
                body: formData,
                headers: {
                    'Authorization': `${token}`
                }
            });
            const data = await response.json();

            if (response.status === 200) {
                fetchData();
                Swal.fire({
                    icon: 'success',
                    text: 'Service Added Successfully',
                    confirmButtonColor: '#007500',
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: data.error || 'Something went wrong!',
                    confirmButtonColor: '#007500',
                });
            }
        } catch (e) {
            console.error("Error adding service: ", e);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
                confirmButtonColor: '#007500',
            });
        } finally {
            setIsLogin(false);
        }
    }
};

// Convert minutes to hours and minutes
const convertToHoursMinutess = (durationInMinutes) => {
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;
    return { hours, minutes };
};





  

    const togglePutTooltip = (index) => {
      const putTooltipOpen = [...puttooltipOpen];
      putTooltipOpen[index] = !putTooltipOpen[index];
      setPutToolTipOpen(putTooltipOpen);
    };

  
  
  
    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    };
  
  
    const showSuccessAlert = () => {
      Swal.fire({
        title: 'Success',
        text: 'Service updated successfully!',
        icon: 'success',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
    };
  
    const showFailureAlert = () => {
      Swal.fire({
        title: 'Success',
        text: 'Failed to update Service. Please try again.',
        icon: 'success',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
    };


    const handleEdit = async (category) => {
      const { value: formValues } = await Swal.fire({
        title: 'Update Service',
        html: `
        <style>
          .swalLa {
            text-align: left;
            display: block;
            margin-bottom: 5px;
            margin-left: 90px;
            font-weight: bold;
          }
    
          .swal2-input {
            margin-bottom: 10px;
            padding: 10px;
            border: 1px solid #ccc;
            border-radius: 4px;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
          }
    
          .duration-display {
            font-weight: bold;
            margin-bottom: 10px;
          }
        </style>
        
        <label class="swalLa">Service Name</label>
        <input id="swal-input1" class="swal2-input fin" placeholder="Enter service name" value="${category.service_name}" />
        
        <label class="swalLa">Description</label>
        <input id="swal-input2" class="swal2-input fin" placeholder="Enter description" value="${category.description}" />
        
        <label class="swalLa">Service Duration</label>
        <input id="swal-input3" class="swal2-input fin" placeholder="Enter duration (in minutes)" value="${category.service_duration}" type="number" min="0" />
        <label id="durationDisplay" class="duration-display">Duration: ${convertToHoursMinutes(category.service_duration)}</label>
        
        <label class="swalLa">Service Price</label>
        <input id="swal-input4" class="swal2-input fin" placeholder="Enter price" value="${category.service_price}" type="number" min="0" />
        
        <label class="swalLa">Membership Discount</label>
        <input id="swal-input6" class="swal2-input fin" placeholder="Enter membership discount" value="${category.membership_discount}" type="number" min="0" />
        
        <label class="swalLa">Service Image</label>
        <input id="swal-input5" class="swal2-input fin" type="file" />
        
        <label class="swalLa">Select Gender</label>
        <select id="swal-input-gender" class="swal2-input fin">
          <option value="Male" ${category.gender === 'Male' ? 'selected' : ''}>Male</option>
          <option value="Female" ${category.gender === 'Female' ? 'selected' : ''}>Female</option>
           <option value="Others" ${category.gender === 'Others' ? 'selected' : ''}>Others</option>
        </select>
        
        <label class="swalLa">Select Service Type</label>
        <select id="swal-input-service-type" class="swal2-input fin">
          <option value="Room" ${category.service_type === 'Room' ? 'selected' : ''}>Room</option>
          <option value="Seat" ${category.service_type === 'Seat' ? 'selected' : ''}>Seat</option>
          <option value="Others" ${category.service_type === 'Others' ? 'selected' : ''}>Others</option>
        </select>
        `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: '#007500',
        confirmButtonText: 'Update',
        didOpen: () => {
          const inputDuration = document.getElementById('swal-input3');
          const durationDisplay = document.getElementById('durationDisplay');
    
          inputDuration.addEventListener('input', (event) => {
            const valueInMinutes = event.target.value;
            const convertedDuration = convertToHoursMinutes(valueInMinutes);
            durationDisplay.innerText = `Duration: ${convertedDuration}`;
          });
        },
        preConfirm: () => {
          const serviceName = document.getElementById('swal-input1').value;
          const description = document.getElementById('swal-input2').value;
          const serviceDuration = document.getElementById('swal-input3').value;
          const servicePrice = document.getElementById('swal-input4').value;
          const membershipDiscount = document.getElementById('swal-input6').value;
          const selectedFile = document.getElementById('swal-input5').files[0];
          const gender = document.getElementById('swal-input-gender').value;
          const serviceType = document.getElementById('swal-input-service-type').value;
    
          if (!serviceName || !description || !serviceDuration || !servicePrice || !membershipDiscount || !gender || !serviceType) {
            Swal.showValidationMessage('Please fill in all the required fields');
            return;
          }
    
          return { serviceName, description, serviceDuration, servicePrice, selectedFile, membershipDiscount, gender, serviceType };
        }
      });
    
      if (formValues) {
        const { serviceName, description, serviceDuration, servicePrice, selectedFile, membershipDiscount, gender, serviceType } = formValues;
        const categoryId = localStorage.getItem('selectedCategoryId');
        const token = localStorage.getItem('token');
        const camelCaseServiceName = serviceName.replace(/\b\w/g, char => char.toUpperCase());
    
        const formData = new FormData();
        formData.append('service_name', camelCaseServiceName);
        formData.append('description', description);
        formData.append('service_duration', serviceDuration);
        formData.append('service_price', servicePrice);
        formData.append('membership_discount', membershipDiscount);
        formData.append('gender', gender); // Add gender to form data
        formData.append('service_type', serviceType); // Add service type to form data
        if (selectedFile) {
          formData.append('service_image', selectedFile);
        } else {
          formData.append('service_image', category.service_image);
        }
        formData.append('category_id', categoryId);
    
        try {
          setIsLogin(true);
          const response = await fetch(`${var_api}/api/sub-category-master/put/${category.id}`, {
            method: 'PUT',
            body: formData,
            headers: {
              'Authorization': `${token}`
            }
          });
          const data = await response.json();
    
          if (response.status === 200) {
            fetchData();
            Swal.fire({
              icon: 'success',
              text: 'Service updated successfully',
              confirmButtonColor: '#007500',
            });
            setIsLogin(false);
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: data.error || 'Something went wrong!',
              confirmButtonColor: '#007500',
            });
          }
        } catch (error) {
          console.error('Error updating service:', error);
          Swal.fire('Error', 'Failed to update service. Please try again.', 'error');
        } finally {
          setIsLogin(false);
        }
      }
    };
    
    
    // Function to convert minutes to hours:minutes format
    function convertToHoursMinutes(minutes) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${hours} hour${hours !== 1 ? 's' : ''} ${mins > 0 ? mins + ' minutes' : ''}`;
    };
    
    
    
    


    const handleOpenConfirmation = (categoryId) => {
      setCategoryToDelete(categoryId);
      setShow(true);
  };
  
  const handleCloseConfirmation= ()=>{
      setShow(false)
    };
    const handleDelete = async () => {
      const token = localStorage.getItem('token');
      setIsLogin(true);
      try {
          await axios.delete(`${var_api}/api/masters/sub-category-master/delete/${categoryToDelete}`, {
              headers: {
                  'Authorization': `${token}`
              }
          });
          console.log('Role deleted successfully!');
          fetchData();
          handleCloseConfirmation();
          setIsLogin(false);
      } catch (error) {
          console.error('Error deleting role:', error);
          if (error.response && error.response.status === 401) {
              history.push('/signin');
          }
      }
  };
    // const handleUpdate = async () => {
    //   const { value: formValues } = await Swal.fire({
    //     title: 'Update Profile',
    //     html:
    //       `<input id="swal-input1" class="swal2-input" name='name' placeholder="Name" value="${users.name || ''}">` +
    //       `<input id="swal-input2" class="swal2-input" name='email' placeholder="Email" value="${users.email || ''}">` +
    //       `<input id="swal-input3" class="swal2-input" name='Password' placeholder="Password" value="${users.password || ''}">` +
    //       `<input id="swal-input41" class="swal2-input" name='country' placeholder="Country" value="${users.country || ''}">` +
    //       `<input id="swal-input5" class="swal2-input" name='mobile' placeholder="Mobile" value="${users.mobile || ''}">`,
    //     focusConfirm: false,
    //     showCancelButton: true,
    //     confirmButtonColor: '#007500',
    //     confirmButtonText: 'Submit',
    //     preConfirm: () => {
    //       const input1 = document.getElementById('swal-input1').value;
    //       const input2 = document.getElementById('swal-input2').value;
    //       const input3 = document.getElementById('swal-input3').value;
    //       const input4 = document.getElementById('swal-input41').value;
    //       const input5 = document.getElementById('swal-input5').value;
    
    //       if (!input1 || !input2 || !input3 || !input4 || !input5) {
    //         Swal.showValidationMessage('Please fill in all the required fields');
    //       } else {
    //         return [input1, input2, input3, input4, input5];
    //       }
    //     },
    //   });
    
    //   if (formValues) {
    //     const [name, email, password, country, mobile] = formValues;
    
    //     try {
    //       // Make a PUT request to update the profile
    //       const data = localStorage.getItem('userId')
    //       const response = await axios.put(`${var_api}/api/user/put/`+data, {
    //         name: name,
    //         email: email,
    //         password: password,
    //         country: country,
    //         mobile: mobile,
    //       });
    
    //       if (response.status === 200) {
    //         // Profile updated successfully
    //         showSuccessAlert()
    //       } else {
    //         showFailureAlert ()
    //       }
    //     } catch (error) {
    //       console.error('Error updating profile:', error);
    //       Swal.fire('Error', 'Failed to update profile. Please try again.', 'error');
    //     }
    //   }
    // };

    useEffect(() => {
      fetchData();
    }, []);

    //get the categories data
    const fetchData = async () => {
      setIsLogin(true);
      const token = localStorage.getItem('token');
      const selectedCategoryId = localStorage.getItem('selectedCategoryId');
     try {
      const response = await axios.get(`${var_api}/api/sub-category-master/services/${selectedCategoryId}`,{
        headers: {
          'Authorization': `${token}`
        }
      });
      const data = response.data;
      console.log("categories", data);
      setCategories(data);
      setIsLogin(false);
    }catch (error) {
      console.log('Error fetching data:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
    }
    setIsLogin(false);
      
      }
    };

    const handleSearchChange = (event) => {
      setSearchQuery(event.target.value);
    };
  
    const filteredCategories = categories.filter(category => 
      category.service_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      category.description.toLowerCase().includes(searchQuery.toLowerCase())
    );



      const handleCategoryUpdate = async (data) => {
          const updatedData = {
            category_name: '',
            category_code: '',
            image: '',
          };
        
          const { value: formValues } = await Swal.fire({
            title: 'Update Category',
            html: `
             <label class="swalLaa">Category Name</label>
             <br/>
              <input id="swal-input1" class="swal2-input fin" name="category_name" placeholder="Category Name" value="${data.category_name || ''}">
              <br/>
              <br/>
              <label class="swalLaa">Category Code</label>
              <input id="swal-input2" class="swal2-input fin" name="category_code" placeholder="Category Code" value="${data.category_code || ''}">
              <br/>
              <br/>
              <label class="swalLaa">Category Image</label>
              <input id="swal-input3" class="swal2-input fin" name="image" type="file" accept="image/*">
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#008000',
            confirmButtonText: 'Update',
            cancelButtonColor: '#ff0000', 
            preConfirm: () => {
              return new Promise(async (resolve) => {
                const input1 = document.getElementById('swal-input1').value;
                const input2 = document.getElementById('swal-input2').value;
                const input3 = document.getElementById('swal-input3').files[0];
        
                if (!input1 || !input2) {
                  Swal.showValidationMessage('Please fill in all the required fields');
                  resolve(null);
                } else {

                  console.log("categories",data);
                  console.log("categories",data.image);

                  const camelCaseCategoryName = capitalizeEachWord(input1);
      console.log("camelCaseCategoryName",camelCaseCategoryName);
                  // Create a FormData object to handle the file upload
                  const formData = new FormData();
                  formData.append('category_name', camelCaseCategoryName || data.category_name);
                  formData.append('category_code', input2 || data.category_code);
                  formData.append('cate_image', input3 || data.image);
                  formData.append('shop_name', data.shop_name);
                  formData.append('shop_id',data.shop_id);
        
                  try {
                    // Make a PUT request to update the category
                    const categoryId = data.id; // Replace with the actual category ID
                    const response = await axios.put(`${var_api}/api/categories/api/put/${categoryId}`, formData, {
                      headers: {
                        'Content-Type': 'multipart/form-data', // Set the content type for file upload
                      },
                    });
        
                    if (response.status === 200) {
                      fetchData();
                      // Category updated successfully
                      Swal.fire({
                        icon: 'success',
                        text: 'Category updated successfully',
                        confirmButtonColor: '#007500',
                      });
                    } else {
                      Swal.fire({
                        icon: 'error',
                        text: 'Failed to update category',
                        confirmButtonColor: '#007500',
                      });
                    }
                  } catch (error) {
                    console.error('Error updating category:', error);
                    if (error.response && error.response.status === 401) {
                      history.push('/signin');
                  }
                    Swal.fire('Error', 'Failed to update category. Please try again.', 'error');
                  }
        
                  resolve(formData);
                }
              });
            },
          });
      };

      //go to home
      const handleGoToHome = () => {
        history.push('/sb-home');
      }


      //go to category page back
      const handleGoToBack = () => {
        history.push('/service-categories');
      }
      const convertMinutesToHours = (minutes) => {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        if (hours > 0) {
          return `${hours} hrs ${remainingMinutes} mins`;
        } else {
          return `${remainingMinutes} mins`;
        }
      };


    return(
        <>
{isLogin && <Loader />}
        {/* <h1>{shopName}</h1> */}
        {/* <Header onSearchChange={handleSearchChange}  /> */}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="fw-bolder fs-5">
      <Nav.Link href="#home">
        <button type="button" className="btn btn-md" id="servicecategory" onClick={handleAdd}>
          <i className="bi bi-plus-square" style={{ color: "white", border: "none" }}>{" "} Add Service</i>
        </button>
      </Nav.Link>
    </Nav>
  <Nav className="fw-bolder fs-5">
      <Nav.Link onClick={handleGoToBack}>
        <button type="button" className="btn btn-md" id="servicecategory">
          <i className="bi bi-arrow-left-circle" style={{ color: "white", border: "none" }}>{" "} Go to Back</i>
        </button>
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link onClick={handleGoToHome} style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" id="servicehomecate">
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>


        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <h5 ><span id="servcateheading" >Services => {categoryName}</span>
        <span style={{float:"right",padding:"10px"}}> <Form.Control type="text" placeholder="Search..." value={searchQuery}
          onChange={handleSearchChange} /></span><br/>
        </h5>
        <br/>
        <span style={{padding:"5px 50px", fontSize:"20px"}}>Service Count: {categories.length}</span>
       
        <div id="catediv">
        
        {/* {loading ? (
        <div className="loader-container">
      	  <div className="spinner"></div>
        </div>
      ) : ( */}

      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 row-cols-xl-5 g-3" style={{margin:"auto"}}>
      {filteredCategories.length > 0 ? (
            filteredCategories.map((category) => (
              <div className="col mb-0 ftco-animate" key={category.id}>
                <div className="card" id="servcatecard">
                  <Link to='/sub-category'>
                    <img src={`${var_api}/${category.service_image}`} alt={category.service_name} name='image' id="cateimg" />
                  </Link>
                  <div>
                    <div className="text py-1">
                      <h2 className="mt-1" id="marcate">
                        {category.service_name}
                        <br />
                        <span style={{ fontSize: "15px", color: "black" }}>{category.description}</span>
                        <br />
                        <span style={{ fontSize: "13px", color: "green", fontWeight: "bold" }}>
                          {convertMinutesToHours(category.service_duration)} {" "} 
                        </span>
                        <br/>
                        <span style={{ fontSize: "13px", color: "green", fontWeight: "bold" }}>
                         {category.service_price} $
                        </span>
                        <br />
                        <span style={{ float: "right", fontSize: "20px", color: "red", marginRight: "2px" }}>
                          <i className="bi bi-pencil-square" style={{ color: "blue" }} onClick={() => handleEdit(category)}></i>
                          {/* <i className="bi bi-trash" onClick={() => handleOpenConfirmation(category.id)}></i> */}
                        </span>
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <p className="text-center">No data available</p>
            </div>
          )}
        <br/>
      </div>
    </div>
    <Modal
        show={show}
        onHide={handleCloseConfirmation}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Delete ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={handleCloseConfirmation}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>
        </>
    );
}

export default ServiceSubCategory;


